import Cookies from "js-cookie";
import isEmpty from "lodash.isempty";
import isUndefined from "lodash.isundefined";
import { isPreview, isProduction, isStaging } from "./environment";

export function getCookieDomain(): string | undefined {
  // Staging is a preview deployment but with a fixed ref
  if (isProduction || isStaging) {
    return process.env.NEXT_PUBLIC_ZAPIER_ORIGIN?.replace("https://", ".");
  }
  if (isPreview) {
    return ".zapier-deployment.com";
  }

  return;
}

export const setMetaCookie = (
  accountId: number,
  spans: Record<string, string | number | boolean | undefined>,
) => {
  // Don't set this if there is no accountId
  if (Number.isNaN(accountId)) {
    return;
  }
  // Check for metadata cookie namespaced with the current accountId
  const zapMetaCookie = Cookies.get("zapmeta");
  const parsedCookie = zapMetaCookie ? JSON.parse(zapMetaCookie) : {};
  const newMeta = {
    ...parsedCookie,
    [accountId]: {
      ...(zapMetaCookie ? parsedCookie[accountId] : {}),
      ...spans,
    },
  };

  const domain = getCookieDomain();
  Cookies.set("zapmeta", JSON.stringify(newMeta), {
    expires: 14, // expires in 14 days
    ...(domain ? { domain } : {}), // make this work for subdomains in staging and production
  });
};

export const getMetaCookie = (accountId: number) => {
  // Don't get this if there is no accountId
  if (Number.isNaN(accountId)) {
    return;
  }
  // Check for metadata cookie namespaced with the current accountId
  const zapMetaCookie = Cookies.get("zapmeta");
  if (zapMetaCookie) {
    return JSON.parse(zapMetaCookie)?.[accountId];
  }
  return;
};

export const hasMetaCookie = (accountId: number, requiredSpans?: string[]) => {
  const zapMetaCookie = Cookies.get("zapmeta");
  if (!zapMetaCookie) {
    return false;
  }
  const parsed = JSON.parse(zapMetaCookie)?.[accountId];

  if (!isEmpty(parsed) && requiredSpans?.length) {
    return requiredSpans.reduce((accumulator, span) => {
      if (!accumulator) {
        return false;
      }
      return !isUndefined(parsed[span]);
    }, true);
  }

  return !isUndefined(parsed) || !isEmpty(parsed);
};
